export default __webpack_public_path__ + "static/media/vang.121b965a.jpg";